module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1199.9a8b866b.png";